// Reusable shimmer loader function
function loadContentWithShimmer(selector, contentUrl) {
  const $placeholder = $(selector);

  // Load your content (replace with real AJAX)
  $.ajax({
    url: contentUrl,
    method: "GET",
    beforeSend: function () {
      $placeholder.addClass("shimmer-wrapper");
    },
    success: function (data) {
      // Replace shimmer with content
      $placeholder.removeClass("shimmer-wrapper").html(data);
    },
    error: function () {
      $placeholder
        .removeClass("shimmer-wrapper")
        .html("<p>Error loading content.</p>");
    },
  });
}

// Example Usage:
$(document).ready(function () {
  loadContentWithShimmer("[data-shimmer-content]", "path/to/content.html");
});
